import { useTranslation } from "react-i18next";

// Hook for translating a key inside an object
export default function useStringTranslation(
  object,
  key,
  translationTarget = "translations"
) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  if (object?.[translationTarget]) {
    const translation = object[translationTarget][currentLang];
    return translation && translation !== "" ? translation : object?.[key];
  }

  return object?.[key];
}
